import { Box, styled } from '@mui/material';
import React, { FC, useMemo } from 'react';
import {
  EFilterType,
  FilterValueType,
  IFilterComponentProps,
  TFilter,
  TFilterEvent,
  TFilterType,
} from './filter.types';
import OwnershipFilter from './OwnershipFilter';
import SiteTypeFilter from './SiteTypeFilter';
import { ThemeButton } from 'designSystem';
import RawMaterialFilter from './RawMaterialFilter';
import PartnerFilter from './PartnerFilter';

const FilterComponents: Record<TFilterType, FC<IFilterComponentProps<TFilterType>>> = {
  [EFilterType.OWNERSHIP]: OwnershipFilter,
  [EFilterType.SITE_TYPE]: SiteTypeFilter,
  [EFilterType.PARTNERS]: PartnerFilter,
  [EFilterType.RAW_MATERIALS]: RawMaterialFilter,
};

interface IFilterProps {
  filters: TFilter[];
  onFilterChange: (event: TFilterEvent) => void;
  onFilterReset: () => void;
}

const FilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: 'fit-content',
  padding: theme.spacing(2),
  alignItems: 'center',
  gap: 8,
  borderRadius: 8,
  border: `1px solid ${theme.custom.themeColors.grayScale[20]}`,
  background: theme.custom.themeColors.grayScale[20],
}));

const Filter: FC<IFilterProps> = ({ filters, onFilterChange, onFilterReset }) => {
  const someFilterActive = useMemo(() => filters.some(filter => !!filter.value), [filters]);

  return (
    <FilterContainer>
      {filters.map(({ type, value }) => {
        const FilterComponent = FilterComponents[type];
        return (
          <Box key={type} width={`calc(100% / ${filters.length})`} maxWidth={450}>
            <FilterComponent
              value={value as FilterValueType<TFilterType>}
              onChange={value => onFilterChange({ type: type as EFilterType, value })}
            />
          </Box>
        );
      })}
      {someFilterActive && (
        <ThemeButton color="WHITE" onClick={onFilterReset}>
          Clear filters
        </ThemeButton>
      )}
    </FilterContainer>
  );
};

export default Filter;
